"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

var _UserStatus = _interopRequireDefault(require("../User/UserStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var InspectorInfo = function InspectorInfo(_ref) {
  var inspector = _ref.inspector,
      onUserClick = _ref.onUserClick,
      onStartOnboarding = _ref.onStartOnboarding,
      loading = _ref.loading,
      labels = _ref.labels;
  var contacts = inspector.contacts;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, contacts && contacts.length > 0 ? /*#__PURE__*/_react["default"].createElement(_core.List, null, contacts.map(function (_ref2) {
    var avatar = _ref2.avatar,
        fullName = _ref2.fullName,
        _id = _ref2._id,
        email = _ref2.email,
        inspectorRep = _ref2.inspectorRep;
    return /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], _extends({
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: avatar && avatar.src
      }),
      textLabel: labels.responsible,
      text: fullName
    }, inspectorRep ? {
      onClick: function onClick() {
        // console.log(inspectorRep);
        return onUserClick(inspectorRep._id);
      }
    } : {}), !inspectorRep && !loading && /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !email,
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        return onStartOnboarding(_id);
      }
    }, labels.actions.invite), inspectorRep && !loading && /*#__PURE__*/_react["default"].createElement(_UserStatus["default"], {
      invitedAt: inspectorRep.invitedAt && 'ok',
      activatedAt: inspectorRep.activatedAt && 'ok',
      blocked: inspectorRep.blocked,
      activeLabel: labels.status.active,
      blockedLabel: labels.status.blocked,
      notActiveLabel: labels.status.notActive,
      notInvitedLabel: labels.status.notInvited
    }));
  })) : '');
};

var _default = InspectorInfo;
exports["default"] = _default;